import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../shared/services/admin.service';
import {empty} from '../../../functions';
import {catchError} from 'rxjs/operators';
import {EducationService} from '../../../shared/services/education.service';
import {LocaleService} from '../../../shared/services/locale.service';

@Component({
    selector: 'app-modal-admin-education-level',
    templateUrl: './modal-admin-education-level.component.html',
    styleUrls: ['./modal-admin-education-level.component.scss'],
    standalone: false
})
export class ModalAdminEducationLevelComponent implements OnInit {

  public data:any;

  entity = {
    id: '',
    name: '',
    level: 0,
    schoolType: '',
    educationProfiles: <any[]> [],
    phases: <string[]> [],
    regions: <string[]> []
  };

  newProfile = {
    code: '',
    name: ''
  };

  regions = [];

  newPhase = '';

  /**
   * Constructor
   *
   * @param activeModal
   * @param adminService
   */
  constructor(public activeModal: NgbActiveModal, public locale:LocaleService, public adminService:AdminService, public educationService: EducationService) {

  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.entity = this.data.entity;

    this.locale.apiGetRegions().subscribe((result:any) => {
      if (result) {
        this.regions = Object.assign([], result);
      }
    });

  }

  /**
   * Add a new profile option
   */
  addEducationProfile() {
    if (empty(this.newProfile)) return;
    if (!this.entity.educationProfiles) this.entity.educationProfiles = [];
    this.entity.educationProfiles.push(this.newProfile);
    this.newProfile = {
      code: '',
      name: ''
    };
  }

  /**
   * Delete a profile option from collection
   *
   * @param key
   */
  deleteProfile(key:number) {
    this.entity.educationProfiles.splice(key, 1);
  }

  /**
   * Add a phase options
   */
  addPhase() {
    if (empty(this.newPhase)) return;
    if (!this.entity.phases) this.entity.phases = [];
    this.entity.phases.push(this.newPhase);
    this.newPhase = '';
  }

  /**
   * Delete a phase option
   *
   * @param key
   */
  deletePhase(key:number) {
    this.entity.phases.splice(key, 1);
  }

  /**
   * Save
   *
   * @constructor
   */
  Save() {

    if (!empty(this.entity.id)) {

      this.adminService.apiUpdateEducationLevel(this.entity).pipe(catchError(this.adminService.handleError('apiUpdateEducationLevel', false))).subscribe( (result) => {

        if (result !== false) {
          this.activeModal.close(true);
        }

      });

    } else {
      const { id, ...body } = this.entity;
      this.adminService.apiAddEducationLevel(body).pipe(catchError(this.adminService.handleError('apiAddEducationLevel', false))).subscribe( (result) => {

        if (result !== false) {
          this.activeModal.close(true);
        }

      });
    }
  }

}
